/* eslint-disable max-len */
import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import Layout from '../components/global/layout';
import NavBar from '../components/global/navbar';
import SEO from '../components/global/seo';
import { gatherMLContent } from '../helpers/gather-ml-content';
import './_stories.scss';

const DocumentariesPage = ({ data }) => {
  const mLContentObj = data.mlContent.fields.amlcontent;
  const documentariesContent = gatherMLContent(mLContentObj, 'documentaries');
  const seoSuffix = gatherMLContent(mLContentObj, 'seo_suffix');
  const seoDescription = gatherMLContent(mLContentObj, 'seo_description');
  const { title } = documentariesContent;
  const heroImageCredit = documentariesContent.hero_image_credit;
  return (
    <Layout>
      <SEO
        title={`${title} | ${seoSuffix}`}
        description={(seoDescription || false)}
      />
      <NavBar />
      <div className="stories">
        <div className="stories__hero">
          <GatsbyImage image={data.mlContent.fields.documentaries_hero_image.childImageSharp.gatsbyImageData} className="stories__hero-image" alt="" />
        </div>
        {(heroImageCredit ? (
          <div className="stories__byline">
            {heroImageCredit}
          </div>
        ) : false)}
        <div className="container">
          <h1 className="stories__title">{title}</h1>
          <div className="stories__list">
            {data.mlContent.fields.amldocumentaries.map((item, index) => (
              <div className="stories__list-item" key={index}>
                {(item.image ? (
                  <a href={item.link} target="_blank" rel="noreferrer">
                    <GatsbyImage className="stories__list-item__image" image={item.image.childImageSharp.gatsbyImageData} alt="" />
                  </a>
                ) : false)}
                <div className="stosries__list-item__info">
                  <h4 className="stories__list-item__title">
                    <a href={item.link} target="_blank" rel="noreferrer">
                      {item.title}
                    </a>
                  </h4>
                  <p>
                    {item.publish_date}
                  </p>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
  {
  mlContent: googleDocs {
    fields {
      amlcontent
      amldocumentaries {
        description
        publish_date
        title
        link
        image {
          childImageSharp {
            gatsbyImageData (
              width: 300
            )
          }
        }
      }
      documentaries_hero_image {
        childImageSharp {
          gatsbyImageData (
            width: 1200
          )
        }
      }
    }
  }
}
`;

DocumentariesPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default DocumentariesPage;
